// Selects mock vs. real HTTP API based on VITE_USE_MOCK_API.
// Default = real backend (mock only when VITE_USE_MOCK_API=true).
// To use the in-app mock: set VITE_USE_MOCK_API=true.

import type { LogInquiryApi } from '../types/log.types';
import { logInquiryHttpApi } from './log.api';
import { logInquiryMockApi } from './log.mock';

const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';

export const logInquiryApi: LogInquiryApi = useMock
  ? logInquiryMockApi
  : logInquiryHttpApi;
